import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../enviroment/enviroment';

export interface LandingPageImage {
  url: string;
  alt_text: string;
}

export interface LandingPageRequest {
  org_id: string;
  title: string;
  slug: string;
  content_json?: any;
  custom_html?: string;
  meta_title?: string;
  meta_description?: string;
  seo_tags?: any;
  images: LandingPageImage[];
}

@Injectable({
  providedIn: 'root'
})
export class LandingPageService {
  private apiUrl = environment.apiUrlLanding;

  constructor(private http: HttpClient) { }

  createLandingPage(data: LandingPageRequest): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.apiUrl}/landing-pages`, data, { headers });
  }


  getLandingPagesByOrg(orgId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/landing-pages?org_id=${orgId}`);
  }


  getPageBySlug(slug: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/landing-pages/${slug}`);
  }

  getLandingPageBySlug(orgId: string, slug: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/landing-pages?org_id=${orgId}&slug=${slug}`);
  }

  updateLandingPage(pageId: string, orgId: string, data: LandingPageRequest): Observable<any> {
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  // Agregar org_id al payload
  const payload = {
    ...data,
    org_id: orgId
  };

  return this.http.put(`${this.apiUrl}/landing-pages/${pageId}`, payload, { headers });
}


 deleteLandingPage(pageId: string, orgId: string): Observable<any> {
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  // Tu Lambda espera org_id en el body
  const body = { org_id: orgId };

  return this.http.request('delete', `${this.apiUrl}/landing-pages/${pageId}`, {
    headers,
    body
  });
}

  // Sanitiza el slug en el frontend para mostrar preview
  sanitizeSlug(text: string): string {
    return text
      .toLowerCase()
      .replace(/ñ/g, 'n')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }


}
